import get from 'lodash/get';

import { CARD_TYPE_ID, TYPE_RESULTS } from '../constants';
import findPolycardComponent from '../utils/find-polycard-components';

const { FOUR_STARS_INTERVENTION, CART_INTERVENTION } = TYPE_RESULTS;
const { POLYCARD_ITEM_ID, LEGACYCARD_ITEM_ID } = CARD_TYPE_ID;

export const getRepeatItemIntervention = (results = []) => {
  const cartInterventions = results.filter((item) => item.id === CART_INTERVENTION);

  if (cartInterventions.length >= 2) {
    const allInterventionCards = cartInterventions.flatMap(({ dynamic_access }) => dynamic_access?.cards || []);

    const repeatCards = allInterventionCards.filter((obj, index) => {
      const prop = obj?.polycard ? POLYCARD_ITEM_ID : LEGACYCARD_ITEM_ID;

      return prop !== 'see_more' && allInterventionCards.findIndex((it) => get(it, prop) === prop) !== index;
    });

    return repeatCards.map((card) => ({
      ...card?.content?.add_to_cart_item,
    }));
  }

  return [];
};

const getRepeatProductObject = (results = []) => {
  const repeatProductObject = {};
  const duplicatedCards = [];

  const repeatProducts = results.filter((obj, index) => {
    const prop = !!obj.polycard ? 'polycard.metadata.id' : 'id';

    if (obj.id === CART_INTERVENTION || obj.id === FOUR_STARS_INTERVENTION) {
      duplicatedCards.push(...obj.dynamic_access.cards);
    }

    if (results.findIndex((it) => get(it, prop) === get(obj, prop)) !== index) {
      return true;
    }

    return false;
  });

  duplicatedCards.forEach((card) => {
    const item = results.find((it) => (it.polycard && card.id === it.polycard.metadata.id) || card.id === it.id);

    if (item) {
      repeatProducts.push(item);
    }
  });

  const repeatInterventionCards = getRepeatItemIntervention(results);

  if (repeatInterventionCards.length !== 0) {
    repeatInterventionCards.forEach((card) => {
      repeatProducts.push(card);
    });
  }

  // eslint-disable-next-line array-callback-return
  repeatProducts.map((it) => {
    if (it.cpg) {
      repeatProductObject[it.id] = {
        quantity: it.cpg.quantity,
        label_count: it.cpg.label_count,
        max_stock: it.available_quantity,
      };
    }

    if (it.polycard) {
      const polyId = it?.polycard?.metadata?.id || it?.polycard?.metadata?.product_id;
      const polycardComponent = findPolycardComponent(it, 'add_to_cart');

      if (polycardComponent?.add_to_cart) {
        repeatProductObject[polyId] = {
          quantity: polycardComponent?.add_to_cart?.cart_status?.quantity,
          label_count: {
            text:
              polycardComponent?.add_to_cart?.cart_status?.format_value ||
              polycardComponent?.add_to_cart?.cart_status?.quantity,
          },
          max_stock: polycardComponent?.add_to_cart?.cart_config?.available_quantity,
        };
      }
    }
  });

  return repeatProductObject;
};

export { getRepeatProductObject };
